if (!customElements.get("article-table")) {
  customElements.define(
    "article-table",
    class ArticleTable extends HTMLElement {
      constructor() {
        super();

        this.activeLink = "";
        this.articleContent = document.querySelector("[data-content]");
        this.sidebarHeadings = this.querySelector("ul");

        this.options = {
          rootMargin: "-30% 0% -60% 0%",
          threshold: 1.0,
        };

        this.articleHeadings = Array.from(
          this.articleContent.querySelectorAll("h3, h2, h1")
        );

        this.articleHeadings.forEach((heading, index) => {
          const anchor = handleize(heading.innerText);

          heading.setAttribute("id", anchor);
          const a = document.createElement("a");
          a.classList.add("py-3");
          a.innerText = heading.innerText;
          a.setAttribute("href", `#${anchor}`);
          a.addEventListener("click", this.anchorWasClicked.bind(this));

          const li = document.createElement("li");
          li.setAttribute("data-id", `${anchor}`);
          if (index === 0) this.activeLink = li;
          index === 0 && li.classList.add("active");
          li.appendChild(a);
          this.sidebarHeadings.appendChild(li);

          index == this.articleHeadings.length - 1 && this.initObservers();
        });
      }

      anchorWasClicked(e) {
        const activeLink = e.currentTarget.parentElement;

        if (this.activeLink == activeLink) return false;
        this.activeLink.classList.remove("active");
        activeLink.classList.add("active");
        this.activeLink = activeLink;
      }

      initObservers() {
        // if (window.innerWidth < 990 || this.dataset.viewport != "desktop")
        if (window.innerWidth < 990) return false;

        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            const target = entry.target;
            const activeLink = this.sidebarHeadings.querySelector(
              `[data-id="${target.getAttribute("id")}"]`
            );

            if (entry.isIntersecting) {
              if (this.activeLink == activeLink) return false;

              this.activeLink.classList.remove("active");
              activeLink.classList.add("active");
              this.activeLink = activeLink;
            }
          });
        }, this.options);

        this.articleHeadings.map(
          (heading) =>
            "IntersectionObserver" in window && this.observer.observe(heading)
        );
      }
    }
  );
}

document
  .querySelector(".page--sidebar-quicklinks .panel")
  .addEventListener(
    "click",
    (e) =>
      e.target.tagName.toLowerCase() === "a" &&
      e.currentTarget.closest("details").querySelector("summary").click()
  );
